import React from "react";

const About = () => {
  return (
    <div className="container">
      <h1>Conditions of Use</h1>
      <h4>Last updated: May 8, 2022</h4>

      <p>
        Welcome to Paratronics.com. Paratronics.com Services LLC and/or its affiliates
        ("Paratronics") provide website features and other products and services to
        you when you visit or shop at Paratronics.com, use Paratronics products or
        services, use Paratronics applications for mobile, or use software provided
        by Paratronics in connection with any of the foregoing (collectively, "Paratronics
        Services"). By using the Paratronics Services, you agree, on behalf of
        yourself and all members of your household and others who use any
        Service under your account, to the following conditions.
      </p>

      <p>
        Please read these conditions carefully. We offer a wide range of Paratronics
        Services, and sometimes additional terms may apply. When you use an
        Paratronics Service (for example, Your Profile, Gift Cards, Paratronics Video,
        Your Media Library, Paratronics devices, or Paratronics applications) you also
        will be subject to the guidelines, terms and agreements applicable to
        that Paratronics Service ("Service Terms"). If these Conditions of Use are
        inconsistent with the Service Terms, those Service Terms will control.
      </p>

      <h1>PRIVACY</h1>
      <p>
        Please review our Privacy Notice, which also governs your use of Paratronics
        Services, to understand our practices.
      </p>

      <h1>ELECTRONIC COMMUNICATIONS</h1>
      <p>
        When you use Paratronics Services, or send e-mails, text messages, and other
        communications from your desktop or mobile device to us, you may be
        communicating with us electronically. You consent to receive
        communications from us electronically, such as e-mails, texts, mobile
        push notices, or notices and messages on this site or through the other
        Paratronics Services, such as our Message Center, and you can retain copies
        of these communications for your records. You agree that all agreements,
        notices, disclosures, and other communications that we provide to you
        electronically satisfy any legal requirement that such communications be
        in writing.
      </p>

      <h1>COPYRIGHT</h1>

      <p>
        All content included in or made available through any Paratronics Service,
        such as text, graphics, logos, button icons, images, audio clips,
        digital downloads, data compilations, and software is the property of
        Paratronics or its content suppliers and protected by United States and
        international copyright laws. The compilation of all content included in
        or made available through any Paratronics Service is the exclusive property
        of Paratronics and protected by U.S. and international copyright laws.
      </p>
    </div>
  );
};

export default About;
